import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { routes } from '@platform/core/lib/routes';
import { FieldChipGrid } from '../../insights/FieldChipGrid';
import type { IChipMatrixRow } from '../../insights/IChipMatrixRow';
import type { IChipMatrixVizProps } from './IChipMatrixVizProps';
import { useVizLabels } from './useVizLabels';
import { useVizRecords } from './useVizRecords';
import '../../insights/fieldMatrix.css';

/**
 * Матриця SWOT або TOWS запису-аналізу (прототип v4 vizMx): підсумок «Аналізів: 1 · елементів SWOT: N» і ключ тонів; сітка «рядки ↓ ·
 * колонки →» з приміткою в кожній клітинці й чипами записів дочірньої таблиці в тоні клітинки; клік відкриває запис.
 */
export function ChipMatrixViz({ ws, module, rt, record, layout }: IChipMatrixVizProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { source, items } = useVizRecords(ws, module, rt.key, record, layout.field, layout.skipArchived);
  const label = useVizLabels(source?.rt);
  const rows: IChipMatrixRow[] = layout.rows.map((row) => ({
    key: row.key, label: t(row.label),
    cells: row.cells.map((cell) => ({
      key: cell.value, hot: false, note: t(cell.note),
      chips: items.filter((r) => r.values[layout.field] === cell.value).map((r) => ({
        key: r.id, label: r.title || r.display, tone: cell.tone, title: [label.option(layout.field, cell.value), r.title, r.values['uses']].filter(Boolean).join(' · '),
        onClick: () => { if (source) navigate(routes.record(module.module.key, source.rt.key, r.id)); },
      })),
    })),
  }));
  return (
    <div className="viz fmx fmx--chips">
      <div className="fmx-top">
        <span className="fmx-sub">{t(layout.summary, { analyses: 1, n: items.length })}</span>
        {layout.keys.length > 0 && (
          <div className="fmx-keys">
            {layout.keys.map((k) => <span key={k.label} className="fmx-key"><span className={`fmx-key__swatch fmx-tone-${k.tone}`} />{t(k.label)}</span>)}
          </div>
        )}
      </div>
      <FieldChipGrid corner={t('recordPage.viz.corner', { rows: t(layout.rowsAxis), cols: t(layout.colsAxis) })} columns={layout.cols.map((c) => t(c))} rows={rows} />
    </div>
  );
}
